import React from 'react'
import styles from './Navbar.module.css'
import mainlogo from '../Images/Mainlogo.svg'

const Navbar = () => {
  return (
    <>
      <div className={styles.Nav}>
        <img src={mainlogo} alt="" className={styles.mainlogo} />
        <div className={styles.Map}>MapMetrics</div>

      </div>
    </>
  )
}

export default Navbar
